import styled from "styled-components"

const Pre = styled.pre`
  color: ${props => props.theme.colors.black};
  font-family: ${props => props.theme.fonts.serif};
  font-size: 0.9em;
  margin: 0.9em 0 0 0;
`

export default Pre
